export const ACTIONS_SERICE_LEVEL = {
  CREATE: 'serviceLevel/addServiceLevel',
  UPDATE: 'serviceLevel/updateServiceLevel',
  FETCH: 'serviceLevel/fetchServiceLevel',
  SEARCHED: 'serviceLevel/search',
  ACTIVATE_AND_DEACTIVATE: 'serviceLevel/activateServiceLevel',
  SERVICE_LEVEL_TYPE: 'serviceLevel/fetchServiceLevelType',
  SERVICE_LOCATION: 'serviceLevel/fetchServiceLocation',
  SERVICE_OFFERING_ADD_ON: 'serviceLevel/fetchContactServiceOfferingAddOn',
  SERVICE_SHIP_METHOD: 'serviceLevel/fetchShipMethod',
  SERVICE_PRICE_LEVEL: 'serviceLevel/fetchServicePriceLevel',
  SERVICE_LEVEL_SEARCH: 'serviceLevel/fetchServiceLevelSearchName',
  SERVICE_LEVEL_STATUS: 'serviceLevel/deactivateAndActivateServiceLevel',
  FETCH_SERVICE_PRICE_LEVEL: 'serviceLevel/fetchServicePriceLevel',
  FETCH_WORK_ORDER_TYPE: 'serviceLevel/fetchWorkOrderType',
  SERVICE_RESPONSE_TYPE: 'serviceLevel/fetchServiceResponseType',
  NOTE_TYPE: 'serviceLevel/fetchNoteType',
  REVIEW_STATUS: 'serviceLevel/fetchReviewStatus',
  CASE_TYPE: 'serviceLevel/fetchCaseType',
  CHARGE_CODE: 'ServiceLevel/chargeCode',
  USER_PERMISSIONS: 'ServiceLevel/userPermissions',
  USER_LOGIN_ACTIVITY: 'ServiceLevel/userLoginActivity',
  getContractHistoryTypes: 'ServiceLevel/getContractHistoryTypes',
};

export const ACTIONS_ERP_PRODUCT = {
  SEARCH_PRODUCT_CODE: 'erpProductSearch/searcProductCodeContain',
  SEARCH_PRODUCT_NAME_CONTAINS: 'erpProductSearch/searchProductName',
  SEARCH_ALL_PRODUCT: 'erpProductSearch/searchAllProduct',
  FETCH_HARDWARE_CLASS: 'erpProductSearch/hardwareClass',
  GET_PRODUCT_TYPE: 'erpProductSearch/productType',
  SEARCH_PRODUCT_NAME: 'erpProductSearch/searchProductName',
  SEARCH_PRICE_CLASS: 'erpProductSearch/searchPriceClassContain',
  GENERAL_INFO_TAB: 'erpProductDisplay/generalInfoTab',
  PRODUCT_FAMILY: 'erpProductDisplay/productFamily',
  SALES_INFO_TAB: 'erpProductDisplay/salesInfo',
  SERVICE_INFO_MODEL: 'erpProductDisplay/serviceInfoModel',
  SERVICE_INFO_SUBMODEL: 'erpProductDisplay/serviceInfoSubModel',
  FETCH_SERVICE_FEE: 'erPProductDisplay/fetchServiceFee',
  FETCH_SERVICE_GRID_DATA: 'erpProductDisplay/FetchserviceFeeGridData',
  SET_SERVICE_FEE: 'erpProductDispaly/setSetviceFee',
  SERVICE_PRODUCT_DETAILS: 'erpProductDisplay/serviceProductDetails',
  END_OF_SERVICE_GRID_DATA: 'erpProductDisplay/endOfServiceGridData',
  GENERAL_INFO_SAVE: 'erpProductDisplay/generalInfoSave',
  SAVE_MODELS_N_SUBMODELS: 'erpProductDisplay/saveModelsNSubModels',
  SAVE_SERVICE_INFO_FEE: ' erpProductDisplay/serviceInfoFee',
  SAVE_END_OF_SERVICE: 'erpProductDisplay/saveEndOfService',
  SERVICE_INFO_MODEL_DATE_VALIDATION:
    'erpProductDisplay/serviceInfoModelDateValidation',
  SERVICE_INFO_SUBMODEL_DATE_VALIDATION:
    'erpProductDisplay/serviceInfoSubModelDateValidation',
  EOS_JOB: 'erpProductDisplay/eos',
  EOS_ACCEPT_BUTTON: 'erpProductDisplay/ServiceProductContractOverride ',
};

export const ACTIONS_PRICE_SHEET = {
  FETCH_ACCOUNTING_GROUPS: 'priceSheet/fetchAccountingGroupsData',
  FETCH_COUNTRIES: 'priceSheet/fetchCountriesData',
  FETCH_PRICE_TYPES: 'priceSheet/fetchPriceTypesData',
  FETCH_PRICES_DATA: 'priceSheet/fetchPricesGetData',
  REQUEST_ACCOUNTING_GROUP_SEARCH: 'priceSheet/accountingGroupSearchData',
  FETCH_COUNTRIES_SEARCH: 'priceSheet/countriesSearchData',
  REQUEST_PRICESHEET_SEARCH: 'priceSheet/priceSheetSearchData',
  GET_PRICESHEET_ID: 'priceSheet/priceSheetGetData',
  GET_PRICES: 'priceSheet/pricesGetData',
  GET_PRICESHEET_NOTES: 'priceSheet/priceSheetNotesData',
  GET_PRICESHEET_AUDIT_TRAIL: 'priceSheet/priceSheetAuditTrailData',
  GET_PRICECLASS_SERVICE_OFFERINGS:
    'priceSheet/fetchPriceClassServiceOfferings',
  REQUEST_PRICESHEET_SAVE: 'priceSheet/priceSheetSaveData',
  REQUEST_PRICESHEET_COPY_SAVE: 'priceSheet/priceSheetCopySaveData',
  REQUEST_PRICESHEET_SEARCH_COUNT: 'priceSheet/priceSheetSearchDataCount',
};

export const ACTIONS_BILL_CLASS = {
  FETCH_BILL_CLASS: 'billClass/fetchBillClass',
  SEARCH_BILL_CLASS: 'billClass/searchBillClass',
  REMOVE_BILL_CLASS: 'billClass/removeBillClass',
  ADD_BILL_CLASS: 'billClass/addBillClass',
};

export const ACTIONS_WARRANTY = {
  WARRANTY: 'warranty/fetchWarranty',
  AUTOCOMPLETE_SEARCH: 'warranty/searchAutocomplete',
  WARRANTY_SEARCH: 'warranty/searchWarranty',
  WARRANTY_DETAIL: 'warranty/fetchDetail',
  WARRANTY_ENTITLEMENT: 'warranty/fetchEntitlement',
  WARRANTY_SERIALNOHISTORY: 'warranty/fetchSerialNoHistory',
};

export const ACTIONS_CONTRACTS = {
  FETCH_CONTRACTS_BY_ID: 'contracts/fetchContractsById',
  FETCH_CONTRACTS: 'contracts/fetchContracts',
  CONTRACT_ID_SEARCH: 'contracts/fetchContractIdSearch',
  FETCH_ACCOUNTING_GROUPS: 'contratcs/fetchAccountingGroupsData',
  FETCH_COUNTRIES: 'contratcs/fetchCountriesData',
  FETCH_CUSTOMER: 'contracts/fetchCustomerData',
  //FETCH_BILLTO: 'contracts/fetchCustomerData',
  FETCH_SITE: 'contracts/fetchSiteData',
  FETCH_STATUS: 'contracts/fetchStatusData',
  FETCH_LEVEL: 'contracts/fetchLevelData',
  FETCH_APPROVALS: 'contracts/fetchApprovals',
  APPROVE_NOTES: 'contract/approvalContracts',
  TRICKLE: 'contract/trickle',
  SAVE_CONTRACTS_DESCRIPTION: 'contract/saveDescription',
  FETCH_RELATED_CONTRACTS: 'contracts/fetchRelatedContracts',
  FETCH_AUDIT_TRAIL: 'contracts/fetchAuditTrail',
};

export const ACTIONS_COPY_CONTRACT = {
  FETCH_CONTRACT_DETAILS_BY_ID: 'copyContract/fetchContractDetailsById',
  FETCH_PRICE_AND_SERVICE_MAP: 'copyContract/fetchServiceAndMapData',
  FETCH_COPY_CONTRACT_DATA: 'copyContract/fetchCopyContract',
};

export const ACTIONS_ADD_NEW_CONTRACT = {
  CREATE_NEW_CONTRACT: 'addContracts/createNewContractId',
  FETCH_ACCOUNTING_GROUPS: 'addContracts/fetchAccountingGroupsData',
  FETCH_COUNTRIES: 'addContracts/fetchCountriesData',
  FETCH_CUSTOMER: 'addContracts/fetchCustomerData',
  FETCH_BILLTO: 'addContracts/fetchBillToData',
  FETCH_SITE: 'addContracts/fetchSiteData',
  FETCH_SITE_TYPE: 'addContracts/fetchSiteTypeData',
  RETURN_TO_CREATE_NEW_CONTRACT: 'addContracts/returnToCeateNewContractId',
};
export const ACTION_SALES_MAPPING_UNSUPPORTED_TAB = {
  SEARCH_UNSUPPORTED_REPORT: 'salesMapping/searchUnsupportedReport',
  SEARCH_SALES_ORDER: 'salesMapping/searchSalesOrder',
  ADD_UNSUPPORTED_SALES: 'salesMapping/unsupported',
  DELETE_UNSUPPORTED_SALES: 'salesMapping/unsupported/delete',
};

export const ACTION_SALES_MAPPING_SALES_ORDER_TAB = {
  SEARCH_SALES_ORDER_REPORT: 'salesMapping/searchSalesOrderReport',
  SEARCH_HIGHER_SALES_ORDER_REPORT: 'salesMapping/searchHigherSalesOrderReport',
  SAVE_SALES_ORDER_HOC_REPORT: 'salesMapping/saveHOCReport',
};

export const ACTIONS_E_TRACK_SETTINGS = {
  FETCH_ENTITEMENT: 'eTrackSettings/fetchEntitelmentSetup',
  UPDATE_ENTITEMENT: 'eTrackSettings/updateEntitelmentSetup',
  FETCH_SALES_IMPORT: 'eTrackSettings/fetchSalesImport',
  UPDATE_SALES_IMPORT: 'eTrackSettings/updateSalesImport',
  FETCH_ACCOUNTING_GROUP: 'eTrackSettings/fetchAccountingGroup',
  UPDATE_ACCOUNTING_GROUP: 'eTrackSettings/updateAccountingGroup',
};

export const ACTION_PRICE_CLASS = {
  SEARCH_PRICE_CLASS: 'priceClass/searchPriceClassData',
  FETCH_PRICE_CLASS_DATA: 'priceClass/fetchPriceClassData',
};

export const ACTIONS_SALES_MAPPING_ORDERABLE_TAB = {
  SEARCH_PRODUCT_CODE_NAME: 'salesMappingOrderableTab/searchProductCodeName',
  FETCH_SERVICE_LEVEL_NAME: 'salesMappingOrderableTab/fetchServiceLevelName',
  DELETE_ORDERABLE: 'salesMappingOrderableTab/deleteOrderable',
  SAVE_ORDERABLE: 'salesMappingOrderableTab/saveOrderable',
  FETCH_ORDERABLE_DATA: 'salesMappingOrderableTab/fetchOrderableData',
  FETCH_ORDERABLE_COMPARE_DATA:
    'salesMappingOrderableTab/fetchOrderableCompareData',
};

export const ACTIONS_SALES_MAPPING_SUPPORTED_TAB = {
  FETCH_SUPPORTED_ZONE: 'salesMappingSupportedTab/fetchSupportedZone',
  ADD_SUPPORTED: 'salesMappingSupportedTab/addSupported',
  FETCH_SUPPORTED: 'salesMappingSupportedTab/fetchSupported',
  FETCH_OVERRIDE: 'salesMappingSupportedTab/override',
  DELETE_SUPPORTED: 'salesMappingSupported/delete',
};

export const ACTIONS_CUSTOMERS = {
  SEARCH_PRODUCT_CODE: 'customersSearch/searcProductCodeContain',
  SEARCH_PRODUCT_NAME_CONTAINS: 'customersSearch/searchProductName',
  SEARCH_BY_GLOBAL_CUSTOMER_NO: 'customersSearch/byGlobalCustomerNo',
  SEARCH_ALL_CUSTOMERS_BY_MULTIPLE_INPUTS:
    'customersSearch/searchAllCustomersByMultipleInputs',
  SEARCH_ALL_CUSTOMERS_FOR_PARENT_GLOBAL_MODAL:
    'customersSearch/searchAllCustomersForParentGlobalModal',
  FETCH_ACCOUNTING_GROUPS: 'customersSearch/fetchAccountingGroupsData',
  GET_DETAILS_BY_CUSTOMER_ID: 'customersSearch/getDetailsByCostomerId',
  GET_ADDRESS_DETAILS_BY_CUSTOMER_ID:
    'customersSearch/getAddressDetailsByCostomerId',
  GET_CUSTOMER_HISTORY: 'customersSearch/getCustomerHistory',
  GET_CUSTOMER_CHILDREN: 'customersSearch/getCustomerChildren',
  GET_CUSTOMER_NOTES: 'customersSearch/getCustomerNotes',
  ADD_CUSTOMER_NOTES: 'customersSearch/addCustomerNotes',
  DELETE_CUSTOMER_NOTES: 'customersSearch/deleteCustomerNotes',
  ORDER_NUMBER_SMART_SEARCH: 'customersSearch/orderNumberSmartSearch',
  SITE_ID_SMART_SEARCH: 'customersSearch/siteIDSmartSearch',
  SALES_ORDER_CUSTOMER_SEARCH: 'customersSearch/customerSearch',
  SEARCH_CUSTOMER_ENTITLEMENT_SUMMARY:
    'customersSearch/bySearchEntitlementSummary',
  SEARCH_CUSTOMER_SITE: 'customersSearch/bySearchCustomerSite',
  FETCH_CUSTOMER_BILL_NOTES: 'customersSearch/fetchCustomerBillNotes',
  FETCH_CUSTOMER_BILLS_BILL: 'customersSearch/fetchCustomerBillingBills',
  UPDATE_CUSTOMERS_INFO: 'customersSearch/updateCustomersInfo',
  VIEW_BILLING: 'billing/view',
  SEND_ENTITLEMENT_SUMMARY_EMAIL: 'customersSearch/sendEntitlementSummaryEmail',
};

export const ACTIONS_ERP_ORDERS = {
  GET_ORDER_TYPES: 'erpOrders/getOrderTypes',
  SEARCH: 'erpOrders/search',
  SEARCH_BY_NUMBER: 'erpOrders/searchByNumber',
  MASTER_CUSTOMER_NUMBER: 'erpOrders/masterCustomerNumber',
  IMPORT_STATUS: 'erpOrders/importStatus',
  MAPPING_TYPE: 'erpOrders/mappingType',
  NCR_SITE_ID: 'erpOrders/siteId',
  SEARCH_ERP_ORDER: 'erpOrder/searchOrder',
  SITE_TYPE: 'erpOrder/siteType',
  SEARCH_BILL_TO_CUSTOMER: 'erpOrder/billToCustomer',
};

export const ACTION_OOS_BILL_SETS = {
  FETCH_OOS_BILL_SETS_SUGGESTIONS: 'ossBillSets/fetchOosBillSetsSuggestion',
  FETCH_OSS_BILL_SETS_ALL_DATA: 'ossBillSets/fetchOosBillSetsAllData',
  FETCH_COUNTRIES: 'ossBillSets/fetchCountriesData',
  FETCH_CURRENCIES: 'ossBillSets/fetchCurrenciesData',
  FETCH_SERVICE_TYPE: 'ossBillSets/fetchServiceTypeData',
  ADD_BILL_SETS: 'ossBillSets/addBillSets',
  UPDATE_BILL_SETS: 'ossBillSets/updateBillSets',
  DELETE_BILL_SETS: 'ossBillSets/deleteBillSets',
  FETCH_OSS_BILL_SETS_BY_ID: 'ossBillSets/fetchOosBillSetsById',
  OSS_BILL_SET_DELETED: 'ossBillSets/oosBillSetDeleted',
};

export const ACTIONS_NOTES = {
  GET_NOTES: 'notes/fetchNotes',
  POST_NOTES: 'notes/postNotes',
};

export const ACTIONS_WARRANTITY_EXTENDED_SERVICES = {
  FETCH_SERVICE_OFFERINGS: 'contracts/getPriceClassesServiceOfferingsData',
  FETCH_DEFERRAL_SERVICE_OFFERINGS: 'contracts/getDeferralSeOfferingsData',
  DEFERRAL_PRICE_CLASSES_SEARCH: 'contracts/deferralPriceClassess',
  EXTENDED_WARRANTY_SAVE: 'contracts/extendedWarrantySave',
  GET_CONTRACT_PRICE_CLASSES: 'contracts/getContractPriceClasses',
  GET_SELECTED_OPTIONS_PRICE_CLASSES: 'contracts/getSelectedOptionPriceClasses',
  GET_CONTRACT_PRICE_CLASS_OPTION: 'contracts/getPriceClassWithServices',
  GET_CONTRACT_SERVICE_OFFERINGS: 'contracts/grtContractServiceOfferings',
  GET_DEFFARAL_SERVICE_OFFERING: 'contracts/defServiceOffering',
  PUT_TRICKLE_DOWN: 'contracts/tricleDown',
  CONTRACTS_UPDATE_PRICECLASSES: 'contracts/contractUpdateSOPriceClasses',
};
export const ACTIONS_SITE_ACTIVITY = {
  FETCH_SITE_ACTIVITY: 'siteActivity/fetchSIteActivityData',
  SITE_SALES_ORDER: 'siteActivity/siteSalesOrder',
  SITE_HISTORY: 'siteHistory',
  SITE_DETAIL: 'siteDetail',
  SITE_NOTES: 'siteNotes',
  SITE_INFO_ACCOUNTING: 'siteInfoAccounting',
  SITE_INFO_ADDRESS: 'siteInfoAddress',
  SITE_INFO_CONTRACT: 'siteInfoContract',
  SITE_TYPES: 'siteTypes',
  SITE_PRICE_OPTIONS: 'siteOption',
};

export const ACTIONS_ENTITLEMENT_HISTORY = {
  UPDATE_ENTITLEMENT_HISTORY_ACTIVE_INACTIVE:
    'entitlementHistory/updateEntitlementHistoryActiveInactive',
  GET_STATUS_ENTITLEMENT: 'entitlementHistory/getEntitlementStatus',
  GET_DATA_ENTITLEMENT: 'entitlementHistory/getSpecificEntitlementData',
  GET_ENTITLEMENT_HISTORY: 'entitlementHistory/getEntitlementHistoryData',
  GET_ENTITLEMENT_HISTORY_VALIDATION:
    'entitlementHistory/getEntitlementHistoryDataValidation',
  CREATE_ENTITLEMENT_HISTORY_NOTE:
    'entitlementHistory/createEntitlementHistoryNote',
  GET_ENTITLEMENT_HISTORY_STATUS:
    'entitlementHistory/getEntitlementHistoryStatus',
  GET_ENTITLEMENT_SERVICE_LEVEL:
    'entitlementHistory/getEntitlementServiceLevel',
  GET_ENTITLEMENT_HISTORY_DETAILS:
    'entitlementHistory/getEntitlementHistoryDetails',
  CREATE_ENTITLEMENT_HISTORY: 'entitlementHistory/createEntitlementHistory',
  GET_ENTITLEMENT_NOTES: 'entitlementHistory/fetchEntitlementNotes',
  CREATE_ENTITLEMENT_NOTE: 'entitlementHistory/createEntitlementNote',
  GET_ENTITLEMENT_PRODUCT_HISTORY:
    'entitlementHistory/getEntitlementProductHistory',
  TRANSFER_ENTITLEMENT: 'entitlementHistory/transferEntitlement',
  TRANSFER_ENTITLEMENT_DATA: 'entitlementHistory/entitlementTransferData',
  ENTITLEMENT_WARRANTY_DATA: 'entitlementHistory/entitlementWarrantyData',
  ENTITLEMENT_SERIAL_NUMBER_HISTORY_DATA:
    'entitlementHistory/entitlementSerialNumberHistory',
  SPECIFIC_WARRANTY_HISTORY_DETAIL_DATA:
    'entitlementHistory/specificWarrantyHistoryDetailsData',
  CHECK_WARRANTY_HISTORY_UPSERT_DATA:
    'entitlementHistory/checkWarrantyHistoryUpsert',
  VALIDATE_WARRANTY_HISTORY_START_DATE:
    'entitlementHistory/validateWarrantyHistoryStartDate',

  CREATE_NEW_ENTITLEMENT_WARRANTY:
    'entitlementHistory/createNewEntitlementWarranty',

  UPDATE_NEW_ENTITLEMENT_WARRANTY:
    'entitlementHistory/updateNewEntitlementWarranty',

  DELETE_NEW_ENTITLEMENT_WARRANTY:
    'entitlementHistory/deleteNewEntitlementWarranty',

  CREATE_UPDATE_NEW_ENTITLEMENT_HISTORY:
    'entitlementHistory/createUpdateNewEntitlementHistory',

  SAVE_AND_CLOSE_ENTITLEMENT_TRANSFER:
    'entitlementHistory/saveAndCloseEntitlementTransfer',
  SAVE_AND_CLOSE_ENTITLEMENT_SITE:
    'entitlementHistory/saveAndCloseEntitlementSite',
  SAVE_AND_CLOSE_ENTITLEMENT_SITE_ACTIVITY:
    'entitlementHistory/saveAndCloseEntitlementSiteActivity',
};

export const ACTIONS_ENTITLEMENTS = {
  FETCH_ENTITLEMENTS_BY_ID: 'entitlements/fetchEntitlementsById',
  FETCH_ENTITLEMENTS_BY_SEARCH_OPTIONS:
    'entitlements/fetchEntitlementsBySearchOptions',
  FETCH_ENTITLEMENTS_SITE_HISTORY_BY_ID:
    'entitlements/fetchEntitlementsSiteHistoryById',
  //Search Options
  FETCH_ACCOUNTING_GROUPS: 'entitlements/fetchAccountingGroupsData',
  FETCH_GLOBAL_CUSTOMERS_NO: 'entitlements/fetchGlobalCustomersNoData',
  FETCH_PRODUCT_NAME_CONTAINS: 'entitlements/fetchProductNameContainsData',
  FETCH_ALL_CUSTOMERS_FOR_PARENT_GLOBAL_MODAL:
    'entitlements/fetchAllCustomersForParentGlobalModal',
  SEARCH_ALL_CUSTOMERS_BY_MULTIPLE_INPUTS:
    'entitlements/searchAllCustomersByMultipleInputs',
  FETCH_SITES: 'entitlements/fetchSitesData',
  FETCH_PRODUCT_CODE_NAME: 'entitlements/searchProductCodeName',
  FETCH_ENTITLEMENTS_STATUS: 'entitlements/fetchEntitlementStatus',
  FETCH_ENTITLEMENTS_TYPE: 'entitlements/fetchEntitlementsType',
};

export const ACTIONS_SITES = {
  STATUS_TYPE: 'sites/statusType',
};

export const ACTIONS_ENTITLEMENT_SHIPPINGINFO = {
  FETCH_SHIPPING_INFO: 'entitlements/fetchShippingInfo',
};

export const ACTIONS_OOS_CASES = {
  SEARCH_PRODUCT_NAME_CONTAINS: 'outOfScopeCases/searchProductName',
  SEARCH_BY_GLOBAL_CUSTOMER_NO: 'outOfScopeCases/byGlobalCustomerNo',
  SEARCH_ALL_CUSTOMERS_BY_MULTIPLE_INPUTS:
    'outOfScopeCases/searchAllCustomersByMultipleInputs',
  FETCH_ACCOUNTING_GROUPS: 'outOfScopeCases/fetchAccountingGroupsData',
  GET_SUMMERY: 'outOfScopeCases/getSummery',
  GET_CASE_ID: 'outOfScopeCases/getCaseId',
  GET_NOTES: 'outOfScopeCases/getNotes',
  GET_CASE_DETAILS: 'outOfScopeCases/getCaseDetails',
  GET_CASE_SITE_DETAILS: 'outOfScopeCases/getCaseSiteDetails',
  GET_OOS_CASE_ITEMS: 'outOfScopeCases/getOOSCaseItems',
  GET_OOS_CASE_ITEM_HISTORY: 'outOfScopeCases/getOOSCaseItemHistory',
  GET_OOS_CASE_ITEM_COMMENT: 'outOfScopeCases/getOOSCaseItemComment',
  GET_OOS_CASE_ITEM_RMA: 'outOfScopeCases/getOOSCaseItemRMA',
  SAVE_OOS_CASE_ITEMS: 'outOfScopeCases/saveOOSCaseItems',
};
export const ACTIONS_SITE_ENTITLEMENT_DETAILS = {
  FETCH_SITE_ENTITLEMENT_DETAILS: 'sites/fetchSiteEntitlementDetails',
  FETCH_SITE_ENTITLEMENT_DETAILS_ENTITLEMENTS_STATUS:
    'sites/fetchSiteEntitlementDetailsEntitlementsStatus',
  FETCH_SERVICE_PRODUCT_DATA: 'site/fetchServiceProductData',
  FETCH_SEVICE_LEVEL_DATA: 'site/serviceLevelData',
  Entitlemen_Summary_Data: 'site/entitlementSummary',
  FETCH_SITE_ENTITLEMENT_DETAILS_COUNT: 'site/fetchSiteEntitlementDetailsCount',
  UPDATE_SITE_ENTITLEMENT_CONTRACT_HISTORY: 'site/updateSiteEntitlementContractHistory',
};
export const ACTIONS_SLECTED_OPTIONS_TAB = {
  UPDATE_SELECTED_OPTION: 'contracts/updateSelectedOptionsData',
  GET_CONTRACT_BILL_SETS: 'contracts/getContractBillSets',
  GET_CONTRCAT_EM_BILL_CYCLES: 'contracts/getEmBillCycle',
  GET_CONTRCAT_DEFAULT_PRICE_OPTIONS: 'contracts/getDefaultPricingOptions',
};
export const CONTRACT_HISTORY = {
  GET_CONTRACT_HISTORY: 'contracts/getContractHistory',
  GET_CONTRACT_HISTORY_CPI: 'contracts/getContractHistoryCPI',
  CONTRACT_HISTORY_VIEW_BACKUP: 'contracts/contractHistoryView',
  CONTRACT_HISTORY_RETURN_CREATE: 'contracts/contractReturnToCreate',
  CONTRACTS_SUBMIT: 'contracts/submitCreate',
};

export const ACTIONS_ENTITLEMENT_SITEACTIVITY = {
  FETCH_SITE_ACTIVITY: 'entitlements/fetchSiteActivity',
  SITE_ACTIVITY_JOB: 'entitlements/siteAPE',
};

export const ACTIONS_SITES_SITEACTIVITYDETAIL = {
  FETCH_SITE_ACTIVITY_DETAILS: 'sites/fetchSiteActivityDetails',
  FETCH_SITE_ACTIVITY_DETAILS_ENTITLEMENTS_BY_SITE_ID:
    'sites/fetchEntitlementsbySiteId',
  UPDATE_SITE_ACTIVITY_DETAILS: 'sites/updateSiteActivityDetails',
  FETCH_HISTORY: 'site/history',
};
export const ACTIONS_ENTITLEMENT_CONTRACT_HISTORY = {
  FETCH_ENTITLEMENT_CONTRACT_HISTORY: 'entitlements/fetchContractHistory',
  UPDATE_ENTITLEMENT_CONTRACT_HISTORY: 'entitlements/updateEntitlementContractHistory',
};

export const ACTIONS_ERP_SALES_ORDER_ITEMS = {
  FETCH_ERP_SALES_ORDER_ITEMS: 'erpSalesOrderItems/fetchErpSalesOrderItems',
  FETCH_IMPORT_STATUS: 'erpSalesOrderItems/fetchImportStatus',
  FETCH_MAPPING_TYPE: 'erpSalesOrderItems/fetchMappingType',
  FETCH_CUSTOMER_NAME_CONTAINS: 'erpSalesOrderItems/customerNameContains',
  UPDATE_ERP_SALES_ORDER_Item: 'erpSalesOrderItems/updateErpSalesOrderItem',
  FETCH_ORDER_GROUP_NAME_CONTAINS:
    'erpSalesOrderItems/fetchOrderGroupNameContains',
  //Modals
  FETCH_ACCOUNTING_GROUPS: 'erpSalesOrderItems/fetchAccountingGroupsData',
  FETCH_PRODUCT_CODE_NAME: 'erpSalesOrderItems/searchProductCodeName',
  FETCH_MCN_ACCOUNTING_GROUPS: 'erpSalesOrderItems/fetchMcnAccountingGroups',
  FETCH_PRODUCT_NAME_CONTAINS: 'erpSalesOrderItems/fetchProductNameContains',
  FETCH_ALL_CUSTOMERS_FOR_PARENT_GLOBAL_MODAL:
    'erpSalesOrderItems/fetchAllCustomersForParentGlobalModal',
  EPR_SALES_ORDER_ITEMS_ENTITLEMENTS:
    'erpSalesOrderItems/getErpSalesItemsEntitlements',
  CREATE_ENTITLEMENTS: 'erpSalesOrderItems/createEntitlement',
  RESET_LINE: 'erpSalesOrderItems/resetLine',
  JOB_CREATE_ENTITLEMENTS: 'erpSalesOrderItems/jobCreateEntitlements',
  ITEMS_TAB: {
    GET_ORDER_ITEMS: 'erpSalesOrderItems/fetchOrderItems',
    SAVE_ERP_LINE_ITEM: 'erpSalesOrderItems/erpSalesOrderLineItemsSave',
    UPDATE_ERP_LINE_ITEM: 'erpSalesOrderItems/updateErpSalesOrderLineItems',
    DELETE_ERP_LINE_ITEM: 'erpSalesOrderItems/deleteErpSalesOrderItems',
    GET_ORDER_LINE_ITEM: 'erpSalesOrderItems/fetchOrderlineItem',
    FETCH_ORDER_ITEMS: 'erpSalesOrderItems/fetchErpSalesOrderItems',
  },
};

export const ACTIONS_WARRANTY_INFO_TAB = {
  RQSMODAL: 'warranty/rqs',
  SEARCHSERIALNO: 'warranty/searchSerialNo',
  WPNSWAP: 'warranty/wpnSwap',
  GETSRINFO: 'warranty/srInfo',
  SEARCHSR: 'warranty/searchSr',
  SWAPESR: 'warranty/swapEsr',
  searchWarranty: 'warranty/search',
};

export const ACTIONS_ETRACK = {
  QUOTE_SEARCH: 'eTrack/quoteSearch',
  SITE_NAME: 'eTrack/siteName',
  SERVICE_MODAL: 'eTrack/fetchServiceModal',
  QUOTE_TYPES: 'eTrack/fetchQuoteTypes',
  CREATE_QUOTE: 'eTrack/createQuote',
  SAVE_QUOTE: 'eTrack/saveQuote',
  DELETE_QUOTE: 'eTrack/deleteQuote',
  SUBMIT_QUOTE: 'eTrack/submitQuote',
  QUOTE_DETAILS: 'eTrack/fetchQuoteDetails',
  QUOTE_SEARCH_PAGINATION: 'eTrack/fetchEtrackSearchQuotePagination',
  SEND_NOTIFICATION: 'eTrac/sendNotification',
  SEND_COPY_NOTIFICATION: 'eTrack/sendCopyMail',
  QUOTE_DETAILS_FOR_EMAIL: 'eTrack/fetchQuoteDetailsForEmail',
  QUOTE_DETAILS_FOR_COPY_EMAIL: 'eTrack/fetchQuoteDetailsForCopyEmail',
  JOB_COMPLETE: 'eTrack/getJobComplete',
  ExportResellerQuote: 'eTrack/ExportResellerQuote',
  ExportClientrQuote: 'eTrack/ExportClientrQuote',
  eTrackApprovalDetail: 'eTrack/approvalDetail',
  FETCH_SITE_TYPE: 'eTrack/fetchSiteTypeData',
  FETCH_MCN_DETAILS_FOR_EXTERNAL_USER: 'eTrack/fetchMCNList',
};

export const ACTIONS_ETRACK_ACTIVITY = {
  QUOTE_DETAIL: 'quoteDetail',
};

export const ACTIONS_BILLING = {
  HISTORYTAB: 'history',
  BILLING_SEARCH: 'billing/search',
  BILLING_STATUS: 'billing/status',
  APPROVE_BILLLS: 'billing/approve',
  SEARCHCPIBYCOUNTRY: 'billing/searchCpi',
  FETCH_BILLING_CONTRACT_DETAILS: 'billing/fetchBlillingContractDetails',
  FETCH_BILLING_TOOL_GRID_DATA: 'billing/fetchBlillingToolGridData',
  FETCH_BILLING_DETAILS_Tab_DATA: 'billing/fetchBillingDetail',
  FETCH_BILLING_TOOL_NOTE_HEADER_DATA: 'billing/fetchBillingNoteHeaderData',
  FETCH_BILLING_TOOL_NOTE_LINE_DATA: 'billing/fetchBillingNoteLineData',
  FETCH_BILLING_LINE_DD_DATA: 'billing/fetchBillingLineDdData',
  ADD_BILING_NOTE_LINE_HEADER: 'billing/addBillingNoteLineHeader',
  ADD_BILING_NOTE_LINE_HEADERS: 'billing/addBillingNoteLineHeaders',
  REGENRATE_BILL: 'billing/regenerateBill',
};

export const ACTIONS_ETRACK_QUOTE_APPROVAL = {
  GET_SUBMISSION_QUEUE: 'submissionQueue',
  GET_SITE_INFO: 'siteInfo',
  hardwareEntitlements: 'Hardware Entitlements',
  billing: 'Billing',
  hardwareEntitlementsId: 3,
  billingId: 4,
  GET_ENTITLEMENTS: 'getEntitlements',
};

export const ACTIONS_CPISETUP = {
  searchByCPI: 'country',
  searchCPISetupTab: 'tab',
  updateCPI: 'updateAmt',
  remove: 'remove',
  updateCpi: 'update',
  getCountry: 'getCountry',
  continueCpi: 'continueCpi',
  putCpiSetupLockdown: 'cpiSetup/putLockdown',
  getCpiSetupLoackdown: 'cpi/getLockdown',
  reset: 'reset',
  GETSPIHISTORY: 'cpi/getCpiHistory',
};

export const ADMIN_SCREEN_ROLE = {
  ROLES: 'admin/roles',
  GETPERMISSIONROLE: 'admin/getPermissionRole',
  SETPERMISSIONROLE: 'admin/setPermissonRole',
  loginWithToken: 'admin/loginWithToken',
};

export const ACTIONS_CONTRACTS_OUTOFSCOPE = {
  FETCH_OOS_COUNTRIES: 'contracts/fetchOOSCountries',
  FETCH_LABOR_FEES_DATA: 'contracts/fetchLaborFeesData',
  FETCH_HARDWARE_FEES_DATA: 'contracts/fetchHardwareFeesData',
  FETCH_HARDWARE_LOGISTICS_DATA: 'contracts/fetchHardwareLogisticsData',
  UPDATE_HARDWARE_FEES_NON_STANDARD_FEES:
    'contracts/updateHardwareFeesNonStandardFees',
  UPDATE_HARDWARE_LOGISTICS_NON_STANDARD_FEES:
    'contracts/updateHardwareLogisticsNonStandardFees',
  UPDATE_HARDWARE_LOGISTICS_NON_STANDARD_CONSUMABLE_FEES:
    'contracts/updateHardwareLogisticsNonStandardConsumableFees',
};

export const ACTIONS_BILLING_CPI_HISTORY = 'billingCpiHistory';

export const ACTIONS_ENTITLEMENT_BILLING_ACTIVITY = {
  FETCH_BILLING_ACTIVITY_DATA: 'entitlement/billingActivity',
  FETCH_BILLING_ACTIVITY_BILLING_DATA: 'entitlement/billingActivityBilling',
};
